import React, { useState, useRef } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { PrimaryButton } from 'office-ui-fabric-react';
import isEmpty from 'lodash/isEmpty';
import TextButton from '../../components/TextButton';
import ContractTermsForm from '../../components/ContractTermsForm';
import Module from '../../components/Module';
import ModuleHeader from '../../components/ModuleHeader';
import ModuleContent from '../../components/ModuleContent';
import Main from '../../components/Main';
import PageTitle from '../../components/PageTitle';
import SavingIndicator from '../../components/SavingIndicator';
import styles from './AddContractTerms.style';

const AddContractTerms = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const history = useHistory();
  const ref = useRef();
  const { contractAddress } = useParams();

  const handleCancel = () => {
    history.push('/');
  };

  const handleSave = async () => {
    setIsSubmitting(true);

    if (!contractAddress || ref.current.dirty) {
      await ref.current.submitForm();
      if (ref.current && !isEmpty(ref.current.errors)) {
        setIsSubmitting(false);
      }
    } else {
      const invalidFields = await ref.current.validateForm();
      if (isEmpty(invalidFields)) {
        if (window.config.enableScopeFilters) {
          history.push(`/contracts/${contractAddress}/add-contract/scope-filters`);
        } else {
          history.push(`/contracts/${contractAddress}/add-contract/royalty-fees`);
        }
      } else {
        setIsSubmitting(false);
      }
    }
  };

  const handleFailure = () => {
    setIsSubmitting(false);
  };

  const handleSuccess = async newContract => {
    setIsSubmitting(false);
    if (window.config.enableScopeFilters) {
      history.push(`/contracts/${newContract.address}/add-contract/scope-filters`);
    } else {
      history.push(`/contracts/${newContract.address}/add-contract/royalty-fees`);
    }
  };

  return (
    <>
      <PageTitle>Add Contract</PageTitle>

      <Main>
        <Module>
          <ModuleHeader variant="xLarge">
            <span className={styles.moduleHeaderText}>Contract Terms</span>
          </ModuleHeader>

          <ModuleContent>
            <ContractTermsForm
              address={contractAddress}
              onSuccess={handleSuccess}
              onFailure={handleFailure}
              ref={ref}
            />
          </ModuleContent>
        </Module>

        <div className={styles.buttonContainer}>
          <TextButton
            className={styles.cancelButton}
            onClick={handleCancel}
            disabled={isSubmitting}
          >
            Cancel
          </TextButton>
          {!isSubmitting ? (
            <PrimaryButton type="submit" onClick={handleSave} disabled={isSubmitting}>
              Save and Continue
            </PrimaryButton>
          ) : (
            <SavingIndicator />
          )}
        </div>
      </Main>
    </>
  );
};

export default AddContractTerms;
